@import "src/styles/common/_colors.scss";
.chillerReportWrapper {
  gap: 1rem;
  display: flex;
  padding: 0.625rem 0;
  height: 100%;
  .radioButtonGroup {
    gap: 0;
    margin-left: -0.5rem;
  }
  .reportListWrapper {
    height: 100%;
    .subSectionContainer {
      margin-left: 20px;
    }
    .reportPanel {
      height: calc(100% - 20px);
      .panelList {
        background: $gray;
        height: 98%;
        overflow-y: visible !important;
        display: flex;
        flex-direction: column;
        border: 1px solid $black;
        .emptyMessage {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
        }
        .panelListInner {
          height: 100%;
          position: relative;
          .reportListHeader {
            border-bottom: 1px solid $orientation-icon-color;
            display: flex;
            gap: 0.25rem;
            height: 30px;
            align-items: center;
            padding: 0.5rem;
            &.noBorder {
              border-bottom: none;
            }
          }
          .reportListBody {
            width: 100%;
            max-height: calc(100% - 30px);
            overflow-y: scroll;
            position: absolute;
            min-height: 200px;
            .propertiesLabel {
              display: flex;
              gap: 0.5rem;
            }
            .editableSectionData {
              margin-left: 2rem;
              display: flex;
              gap: 0.5rem;
            }
            .infoBlock {
              color: $blue;
              cursor: pointer;
            }
          }
          .reportListBodyLoading {
            height: 100%;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
  .yellowText {
    color: $yellow;
  }
  .searchHighlight {
    background-color: $text-highlight;
    color: $white;
  }
}

.description {
  font-size: 12px;
}

.imageWrapperBorder {
  display: flex;
  justify-content: center;
  background-color: #2f2f2f;
  border: 1px solid #303030;
  padding: 15px;
  border-radius: 3px;
}

.imageWrapper {
  background-color: #fff;
  border-radius: 3px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
}

.infoImageBody {
  height: calc(100% - 140px);
  gap: 10px;
}

.underline {
  text-decoration: underline;
}

.hoverC:hover {
  color: #88974f;
}

.hoverC {
  cursor: pointer;
}

.updateBody {
  padding: 0.6rem;
}

.updateFooter {
  position: relative;
  gap: 10px;
}

.updateContainer {
  width: 700px;
}

.modalRoot {
  align-items: flex-start;
}

.chillerProfileWrapper {
  width: 395px !important;
}

.compressorRunHoursAndStartsWrapper {
  width: 500px !important;
}

.chillerLifeWrapper {
  width: 480px !important;
}

.infoFooter {
  position: relative !important;
}

